import { envBasedConfig } from "@/constants/env-based-config.constant";
import { StreamName } from "@/modules/analytics";
import { trackNavClick } from "@/utils/trackNavClick";
import classNames from "classnames";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { isAndroid } from "../header/icons/GetTheApp";
import { ImageWithFallback } from "../image/ImageWithFallback";
import styles from "./BannerDownloadTheApp.module.scss";

export interface BannerDownloadTheAppProps {
  className?: string;
}

export const isBannerActive = (() => {
  if (!envBasedConfig.featureFlags.gettaBanner) {
    return false;
  }
  const today = new Date();
  const targetDate = new Date(2025, 9, 20); // October 20, 2025 (month is 0-indexed)
  return today <= targetDate;
})();

export const BannerDownloadTheAppPlaceholder: FC<BannerDownloadTheAppProps> = ({
  className,
}) => {
  return isBannerActive ? (
    <BannerDownloadTheApp className={className} />
  ) : (
    <></>
  );
};

const BannerDownloadTheApp: FC<BannerDownloadTheAppProps> = ({ className }) => {
  const { t } = useTranslation("web-payments");
  const [isActive, setIsActive] = useState(false);
  const [isAndroidCheck, setisAndroidCheck] = useState(false);

  const linkAndroid = t("GETTA_URL_LINK_ANDROID");
  const linkiOS = t("GETTA_URL_LINK_IOS");
  const text = t("GETTA_BANNER_TEXT");

  const imageLight = t(`GETTA_BANNER_URL_IMAGE_LIGHT`);
  const imageDark = t(`GETTA_BANNER_URL_IMAGE_DARK`);

  useEffect(() => {
    setIsActive(isBannerActive);
    setisAndroidCheck(isAndroid());
  }, []); // Empty dependency array means this runs once on mount

  if (!isActive) {
    return <></>;
  }

  return (
    <div className={classNames(styles.bannercontainer, className)}>
      <p className={classNames("title-7-medium", styles.slogan)}>{text}</p>
      <Link
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        onClick={() => {
          trackNavClick(StreamName.Getta);
        }}
        href={isAndroidCheck ? linkAndroid : linkiOS}
        target="_blank"
        className={styles.anchor}
      >
        <ImageWithFallback
          src={imageLight}
          darkModeSrc={imageDark}
          fallbackImageSrc={imageLight}
          alt="Get the App"
          width={125}
          height={42}
        />
      </Link>
    </div>
  );
};

export { BannerDownloadTheApp };
